module.exports = __webpack_public_path__ + "img/1569313304.797c6be8.jpg";